module.exports = __webpack_public_path__ + "img/w3_trash_solid_black.e937beb3.png";